import { Pipe, PipeTransform } from "@angular/core";

let dictionary = {}

export function setDictionary (dic) {
    dictionary = dic
}

@Pipe({name: 'T', pure: false})
export class T implements PipeTransform {
  transform(value: string): string {
     return dictionary[value]
  }
}
